import {
  MTO_FETCH_REQUEST,
  MTO_FETCH_REQUEST_SUCCESS,
  MTO_FETCH_REQUEST_FAILURE,
  MTO_ADD_REQUEST,
  MTO_ADD_REQUEST_SUCCESS,
  MTO_ADD_REQUEST_FAILURE,
  MTO_UPDATE_REQUEST,
  MTO_UPDATE_REQUEST_SUCCESS,
  MTO_UPDATE_REQUEST_FAILURE,
  MTO_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const mtoReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MTO_FETCH_REQUEST:
    case MTO_ADD_REQUEST:
    case MTO_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MTO_FETCH_REQUEST_SUCCESS:
    case MTO_ADD_REQUEST_SUCCESS:
    case MTO_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
        },
      });

    case MTO_FETCH_REQUEST_FAILURE:
    case MTO_ADD_REQUEST_FAILURE:
    case MTO_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MTO_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default mtoReducer;
